export const version = '3.0.0 pt 5.2: June 27, 2024: Fall of the Octeracts 2'

/**
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 * PSEUDO DO NOT CHANGE THIS LINE
 */
export const testing: boolean = false
export const lastUpdated = new Date(Date.UTC(2024, 8, 28, 1, 56, 42))
/**
 * CHANGE THIS ONE INSTEAD
 */
export const prod: boolean = true
